"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _DownloadReportComponent = _interopRequireDefault(require("./DownloadReportComponent"));
var _downloadHelper = require("../../../helpers/downloadHelper");
var _reportActions = require("../../../redux/actions/reportActions");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var mapStateToProps = function mapStateToProps(state) {
  var _state$report = state.report,
    reports = _state$report.reports,
    reportWriterResults = _state$report.reportWriterResults,
    isLoading = _state$report.isLoading;
  return {
    reports: reports,
    reportWriterResults: reportWriterResults,
    isLoading: isLoading
  };
};
var mapDispatchToProps = {
  getUserReportWriterResults: _reportActions.getUserReportWriterResults,
  downloadDocument: _downloadHelper.downloadDocument
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_DownloadReportComponent["default"]);